/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiChartAttributeFromJSON, ApiChartAttributeToJSON, } from './ApiChartAttribute';
import { ApiChartCrawlerFromJSON, ApiChartCrawlerToJSON, } from './ApiChartCrawler';
import { ApiChartDisplayOptionsFromJSON, ApiChartDisplayOptionsToJSON, } from './ApiChartDisplayOptions';
import { ApiChartHavingFromJSON, ApiChartHavingToJSON, } from './ApiChartHaving';
import { ApiChartRankFromJSON, ApiChartRankToJSON, } from './ApiChartRank';
import { ApiChartTemplateFromJSON, ApiChartTemplateToJSON, } from './ApiChartTemplate';
import { ApiChartTypeFromJSON, ApiChartTypeToJSON, } from './ApiChartType';
import { ApiChartYAxisKeyFromJSON, ApiChartYAxisKeyToJSON, } from './ApiChartYAxisKey';
import { ApiDimensionFromJSON, ApiDimensionToJSON, } from './ApiDimension';
export function ApiChartResponseFromJSON(json) {
    return ApiChartResponseFromJSONTyped(json, false);
}
export function ApiChartResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attributes': !exists(json, 'attributes') ? undefined : (json['attributes'].map(ApiChartAttributeFromJSON)),
        'chartKey': !exists(json, 'chartKey') ? undefined : json['chartKey'],
        'comparison': !exists(json, 'comparison') ? undefined : json['comparison'],
        'crawler': !exists(json, 'crawler') ? undefined : ApiChartCrawlerFromJSON(json['crawler']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'dateDimension': !exists(json, 'dateDimension') ? undefined : ApiDimensionFromJSON(json['dateDimension']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'dimension': !exists(json, 'dimension') ? undefined : json['dimension'],
        'dimensionDecorators': !exists(json, 'dimensionDecorators') ? undefined : (json['dimensionDecorators'].map(ApiChartAttributeFromJSON)),
        'displayOptions': !exists(json, 'displayOptions') ? undefined : ApiChartDisplayOptionsFromJSON(json['displayOptions']),
        'having': !exists(json, 'having') ? undefined : (json['having'].map(ApiChartHavingFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'includeEmpty': !exists(json, 'includeEmpty') ? undefined : json['includeEmpty'],
        'includePublisherReadyOnly': !exists(json, 'includePublisherReadyOnly') ? undefined : json['includePublisherReadyOnly'],
        'includeSubdomains': !exists(json, 'includeSubdomains') ? undefined : json['includeSubdomains'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'orderBy': !exists(json, 'orderBy') ? undefined : json['orderBy'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'ranks': !exists(json, 'ranks') ? undefined : (json['ranks'].map(ApiChartRankFromJSON)),
        'template': !exists(json, 'template') ? undefined : ApiChartTemplateFromJSON(json['template']),
        'type': !exists(json, 'type') ? undefined : ApiChartTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'withTotals': !exists(json, 'withTotals') ? undefined : json['withTotals'],
        'yAxisKeys': !exists(json, 'yAxisKeys') ? undefined : (json['yAxisKeys'].map(ApiChartYAxisKeyFromJSON)),
    };
}
export function ApiChartResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attributes': value.attributes === undefined ? undefined : (value.attributes.map(ApiChartAttributeToJSON)),
        'chartKey': value.chartKey,
        'comparison': value.comparison,
        'crawler': ApiChartCrawlerToJSON(value.crawler),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'dateDimension': ApiDimensionToJSON(value.dateDimension),
        'description': value.description,
        'dimension': value.dimension,
        'dimensionDecorators': value.dimensionDecorators === undefined ? undefined : (value.dimensionDecorators.map(ApiChartAttributeToJSON)),
        'displayOptions': ApiChartDisplayOptionsToJSON(value.displayOptions),
        'having': value.having === undefined ? undefined : (value.having.map(ApiChartHavingToJSON)),
        'id': value.id,
        'includeEmpty': value.includeEmpty,
        'includePublisherReadyOnly': value.includePublisherReadyOnly,
        'includeSubdomains': value.includeSubdomains,
        'limit': value.limit,
        'name': value.name,
        'orderBy': value.orderBy,
        'projectId': value.projectId,
        'ranks': value.ranks === undefined ? undefined : (value.ranks.map(ApiChartRankToJSON)),
        'template': ApiChartTemplateToJSON(value.template),
        'type': ApiChartTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'withTotals': value.withTotals,
        'yAxisKeys': value.yAxisKeys === undefined ? undefined : (value.yAxisKeys.map(ApiChartYAxisKeyToJSON)),
    };
}
